var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/quote-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "quote-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.484 19.3834H5.66732C5.80065 11.6 7.33398 10.3167 12.1173 7.48337C12.6673 7.15003 12.8507 6.45003 12.5173 5.88337C12.2007 5.33337 11.484 5.15003 10.934 5.48337C5.30065 8.8167 3.33398 10.85 3.33398 20.5334V29.5167C3.33398 32.3667 5.65065 34.6667 8.48398 34.6667H13.484C16.4173 34.6667 18.634 32.45 18.634 29.5167V24.5167C18.634 21.6 16.4173 19.3834 13.484 19.3834Z",
    fill: "#93A29B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.5163 19.3834H23.6996C23.8329 11.6 25.3663 10.3167 30.1496 7.48337C30.6996 7.15003 30.8829 6.45003 30.5496 5.88337C30.2163 5.33337 29.5163 5.15003 28.9496 5.48337C23.3163 8.8167 21.3496 10.85 21.3496 20.55V29.5334C21.3496 32.3834 23.6663 34.6834 26.4996 34.6834H31.4996C34.4329 34.6834 36.6496 32.4667 36.6496 29.5334V24.5334C36.6663 21.6 34.4496 19.3834 31.5163 19.3834Z",
    fill: "#93A29B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteUp);
export default __webpack_public_path__ + "static/media/quote-up.b2b89900d9edc11662b19c681a60e17a.svg";
export { ForwardRef as ReactComponent };